import Slider from './Slider';

export default Slider;



// WEBPACK FOOTER //
// ./src/components/CoverPhotoEditor/Slider/index.tsx